import { renderIcon } from '../../../../services/renderIcon.js';
import styles from './FileCard.module.css';

/**
 * Mostra a miniatura de imagem (quando o arquivo é uma foto) ou
 * o ícone correspondente à extensão/tipo do item.
 */
export default function FileCardThumb({ item, thumbUrl, isMusicContext }) {
  const isImage = ['.jpg', '.jpeg', '.png', '.heic'].includes(item.extension);

  if (!isImage) {
    return renderIcon(item.extension, item.name);
  }

  return (
    <img
      src={thumbUrl}
      alt={item.name}
      className={isMusicContext ? styles.imagePreviewMusic : styles.imagePreview}
    />
  );
}